<h1 mat-dialog-title class="resources-title">
  <i class="icon-school icon-text-blue"></i>
  <span rtI18n [rtI18nParams]="{ school: school.SchoolName }">[[school]] Resources</span>
</h1>

<mat-dialog-content class="resources-body">
  <div class="section-header" rtI18n>Links</div>

  <a class="resource-row" [href]="movingUrl" target="_blank" rel="noopener noreferrer">
    <span class="resource-icon">
      <i class="icon-truck icon-action-blue"></i>
    </span>
    <span class="resource-text">
      <span class="resource-title" rtI18n>Moving out of the area?</span>
      <span class="resource-subtitle" rtI18n>Check out our other NHA school locations.</span>
    </span>
    <i class="icon-open-new-page icon-action-blue"></i>
  </a>

  @if (beforeAfterCareUrl) {
    <a class="resource-row" [href]="beforeAfterCareUrl" target="_blank" rel="noopener noreferrer">
      <span class="resource-icon">
        <i class="icon-clock icon-action-blue"></i>
      </span>
      <span class="resource-text">
        <span class="resource-title" rtI18n>Before & After School Care</span>
      </span>
      <i class="icon-open-new-page icon-action-blue"></i>
    </a>
  }

  @for (entry of resourceLinks; track $index) {
    <a class="resource-row" [href]="entry.item.Resource" target="_blank" rel="noopener noreferrer">
      <span class="resource-icon">
        <i class="icon-link icon-action-blue"></i>
      </span>
      <span class="resource-text">
        <span class="title-line">
          <span class="resource-title">{{entry.item.Title}}</span>
          @if (entry.gradeNames.length > 0) {
            <span class="grade-chip">{{entry.gradeNames.join(', ')}}</span>
          }
        </span>
        @if (linkSubtitle(entry); as subtitle) {
          <span class="resource-subtitle">{{subtitle}}</span>
        }
      </span>
      <i class="icon-open-new-page icon-action-blue"></i>
    </a>
  }

  @if (resourceDocuments.length > 0) {
    <div class="section-header" rtI18n>Documents</div>

    @for (entry of resourceDocuments; track $index) {
      <a class="resource-row" [href]="entry.item.Resource" target="_blank" rel="noopener noreferrer">
        <span class="resource-icon doc">
          <i class="icon-pdf icon-red"></i>
        </span>
        <span class="resource-text">
          <span class="title-line">
            <span class="resource-title">{{entry.item.Title}}</span>
            @if (entry.gradeNames.length > 0) {
              <span class="grade-chip">{{entry.gradeNames.join(', ')}}</span>
            }
          </span>
          <span class="resource-subtitle">
            PDF
            @if (entry.item.DateCreated) {
              <span> &middot; {{entry.item.DateCreated | date:'MMM d, y'}}</span>
            }
          </span>
        </span>
        <i class="icon-open-new-page icon-action-blue"></i>
      </a>
    }
  }

  @if (resourcesStatus === ServiceStatus.loading) {
    <div class="resources-loading">
      <mat-spinner [diameter]="28"></mat-spinner>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="btn btn-secondary" mat-dialog-close rtI18n>Close</button>
</mat-dialog-actions>
